import _ from 'lodash';

/**
 * The list of data dependencies that the landing page builder supports.
 * These may be referred to in landing pages' JSON, so don't change in-use
 * values without a migration plan.
 * @type {Object}
 */
export const DATA_DEPENDENCY_TYPES = {
  BANKING: 'banking',
  CDS: 'cds',
  CHECKING: 'checking',
  CREDIT_CARDS: 'creditCards',
  INVESTING: 'investing',
  INSURANCE: 'insurance',
  MORTGAGES: 'mortgages',
  PERSONAL_LOANS: 'personalLoans',
  SAVINGS: 'savings',
  STUDENT_LOANS: 'studentLoans',
};

/**
 * Get readable label for data dependency type.
 * @param {String} dataDependencyType - The enum data dependency type.
 * @returns {String} - The corresponding readable label.
 */
const getReadableLabel = (dataDependencyType: string) => {
  switch (dataDependencyType) {
    case DATA_DEPENDENCY_TYPES.CDS:
      return 'CD Rates';
    default:
      return _.startCase(dataDependencyType);
  }
};

/**
 * Mappings of data dependency type to label.
 * Unlike DATA_DEPENDENCY_TYPES, this representation can be changed as needed.
 * @type {Object}
 */
export const DATA_DEPENDENCY_LABELS = _.reduce(
  DATA_DEPENDENCY_TYPES,
  (labels, dataDependencyType) => ({
    ...labels,
    [dataDependencyType]: getReadableLabel(dataDependencyType),
  }),
  {}
);

export const PRODUCT_TABLE_TYPES = {
  STANDARD: 'standard',
  EXPANDING: 'expanding',
};

export const PAGE_ROOT = '1-Page';
